import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";

export class EnaioDuplicateDataset {
    key: OrdinaryObject;
    keyString: string;
    count = 0;
    ids: number[];
}
